import PropTypes from 'prop-types';
import React from 'react';
import TooltipWrapper from '../../../common/TooltipWrapper';
import styles from './AdditionalInformation.scss';

const AdditionalInformation = ({ id, option }) => {
  const { isOutOfStock, isSoldOut, outOfStockMessage, specialBomCharge } = option;

  return (
    <div className={styles['additional-information']} id={id}>
      {!!specialBomCharge && <span>{specialBomCharge}</span>}
      {isOutOfStock && (
        <span className={styles['out-of-stock']}>
          Out of stock
          <TooltipWrapper
            id={`${id}-out-of-stock-tooltip`}
            message={!!outOfStockMessage ? outOfStockMessage : 'Temporarily out of stock.'}
            trigger={['focus', 'hover']}>
            <span className={styles['out-of-stock-icon']} tabIndex="0" />
          </TooltipWrapper>
        </span>
      )}
      {isSoldOut && <span className={styles['sold-out']}>Sold out</span>}
    </div>
  );
};

AdditionalInformation.propTypes = {
  id: PropTypes.string.isRequired,
  option: PropTypes.shape({
    code: PropTypes.string.isRequired,
    codeValue: PropTypes.string.isRequired,
    colorGroupList: PropTypes.arrayOf(PropTypes.string).isRequired,
    colorReference: PropTypes.string.isRequired,
    componentId: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    estimatedShipDate: PropTypes.string.isRequired,
    futureShipDateSettingStatus: PropTypes.oneOf([0, 1, 2]).isRequired,
    helpLink: PropTypes.shape({
      helpText: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
    }),
    inventoryMessage: PropTypes.string.isRequired,
    isFutureShipDateSettable: PropTypes.bool.isRequired,
    isOutOfStock: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isSoldOut: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
    optionText: PropTypes.string.isRequired,
    outOfStockMessage: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    sequence: PropTypes.number.isRequired,
    specialBomCharge: PropTypes.string.isRequired,
    useTexture: PropTypes.bool.isRequired,
    yearOptionPricing: PropTypes.oneOf([0, 1, 2]).isRequired,
  }).isRequired,
};

export default AdditionalInformation;
